import React, { Fragment } from "react";
import UF_Content from "../../../../nix_components/components/UF_Content";
import withRouter from "../../../../nix_components/components/withRouter";
import data_types from "../../../../nix_components/data/data_types";
import MoveUpIcon from "@mui/icons-material/MoveUp";
import TransferDataModal from "../../../../components/modals/TransferDataModal";
import Tooltip from "@mui/material/Tooltip/Tooltip";
import { IconButton } from "@mui/material";

class PackageSubcategories extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permission: "package",
      transferOpen: false,
      scopeCondition: false,
      loaded: false,
    };
  }

  tools = {
    transfer: () => {
      return this.state.scopeCondition ? (
        <Tooltip title={"Transfer"}>
          <IconButton onClick={() => this.setState({ transferOpen: true })}>
            <MoveUpIcon />
          </IconButton>
        </Tooltip>
      ) : null;
    },
  };

  buttons = {};

  formConfig = {
    rows: [
      [
        "name",
        {
          field: "package_category_id",
          label: "Package category",
          datatype: data_types.reference,
          reference: "package_categories",
          onChange: (params) => {
            global.UF.dataProvider.get(
              `package_categories`,
              { id: params.package_category_id },
              (packageCategories) => {
                if (packageCategories && packageCategories.length) {
                  params.package_id = packageCategories[0].package_id;
                }
              }
            );
          },
        },
      ],
    ],
  };

  gridProps = {
    fields: ["name", "package_category_id", "package_id", "created_at"],
  };

  handleBeforeAddNew = (dataItem, callback) => {
    dataItem.event_id = global.UF.event_id;
    if (callback) {
      callback();
    }
  };

  renderTransferDataModal = () => {
    return (
      <TransferDataModal
        open={this.state.transferOpen}
        onClose={() => this.setState({ transferOpen: false })}
        table={"package_subcategories"}
      />
    );
  };

  findCurrentPermission = () => {
    const user =
      typeof localStorage.getItem("user") === "string"
        ? JSON.parse(localStorage.getItem("user"))
        : localStorage.getItem("user");
    const scopes = user.hasOwnProperty("scopes")
      ? typeof user.scopes === "string"
        ? JSON.parse(user.scopes)
        : user.scopes
      : null;
    this.state.scopeCondition =
      scopes.findIndex(
        (permission) =>
          permission.split(":")[0] === this.state.permission &&
          permission.includes("write")
      ) > -1;
    this.setState({ loaded: true });
  };

  componentDidMount() {
    this.findCurrentPermission();
  }

  render() {
    return (
      <Fragment>
        {this.state.transferOpen && this.renderTransferDataModal()}
        <UF_Content
          table="package_subcategories"
          id={this.props.event_id}
          buttons={this.buttons}
          title="Package Subcategories"
          permission={"package"}
          tools={this.tools}
          formConfig={this.formConfig}
          gridProps={this.gridProps}
          edit={this.state.scopeCondition}
          delete={this.state.scopeCondition}
          export={this.state.scopeCondition}
          add={this.state.scopeCondition}
          sync={this.state.scopeCondition}
          beforeAddNew={this.handleBeforeAddNew}
        />
      </Fragment>
    );
  }
}

export default withRouter(PackageSubcategories);
